import { Box, Typography } from '@mui/material';

const LoadingScreen = () => {
  // Colors pulled from `styles.ts` darkTheme without importing/initializing the theme:
  // background.default: #1d1d1d, background.paper: #252525, primary.main: #e1e1e1
  const bg = '#1d1d1d';
  const paper = '#252525';
  const text = '#e1e1e1';

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        height: '100dvh',
        minHeight: 0,
        maxWidth: '100vw',
        overflow: 'hidden',
        width: '100%',
        display: 'grid',
        placeItems: 'center',
        backgroundColor: bg,
        color: text,
        px: 2,
      }}
    >
      <Box
        sx={{
          boxSizing: 'border-box',
          width: 'min(520px, 100%)',
          maxWidth: '100%',
          backgroundColor: paper,
          borderRadius: 3,
          p: { xs: 4, sm: 5 },
          boxShadow: '0 18px 50px rgba(0,0,0,0.45)',
          border: '1px solid rgba(255,255,255,0.06)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5,
        }}
      >
        <Box
          component="img"
          src="/logo.png"
          alt="PowerAlpha"
          sx={{
            width: { xs: 220, sm: 280 },
            height: 'auto',
            maxWidth: '100%',
            objectFit: 'contain',
            display: 'block',
            filter: 'drop-shadow(0 10px 24px rgba(0,0,0,0.35))',
          }}
        />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            letterSpacing: 0.2,
            textAlign: 'center',
            animation: 'poweralphaPulse 2.2s ease-in-out infinite',
          }}
        >
          PowerAlpha
          <Box
            component="sup"
            sx={{
              fontSize: '0.55em',
              lineHeight: 0,
              verticalAlign: 'super',
              opacity: 0.75,
              ml: 0.2,
            }}
          >
            ®
          </Box>{' '}
          is loading…
        </Typography>
        <Typography
          variant="body2"
          sx={{
            opacity: 0.7,
            textAlign: 'center',
            maxWidth: 360,
          }}
        >
          Preparing your workspace.
        </Typography>

        {/* Scoped keyframes */}
        <style>{`
          @keyframes poweralphaPulse {
            0%, 100% { opacity: 0.35; }
            50% { opacity: 1; }
          }
        `}</style>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
